export const formatAny = (value) => value || 'N/A';
